// Cores das etiquetas de temperatura comercial (Quente/Morna/Fria).
// Padrão tonal do DS (fundo pálido + texto saturado), definido com o Weni:
// - Quente: vermelho tonal (danger)
// - Morna: coral do item ativo do navbar (--nav-active-*) — adapta claro/escuro
// - Fria: azul apagado (info)
export const TEMP_CHIP = {
  quente: 'bg-[rgba(220,38,38,0.10)] text-[var(--danger)]',
  morna: 'bg-[var(--nav-active-bg)] text-[var(--nav-active-fg)]',
  fria: 'bg-[rgba(0,113,227,0.10)] text-[var(--info)]',
} as const;

